import React from 'react';
import '../react-redwood.css';
import './RedwoodInputText.css';
import Icon from "../Icon/Icon";

class RedwoodInputText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false
        };
    }

    onClickHandler = () => {
        this.setState({showInfo: true});
    }

    render() {
        return (
            
            <div>
                <label className={`has-float-label  ${ this.props.valid === false ? 'redBorder' : '' }`}>
                    <input ref={c => (this._input = c) }
                        autoComplete="chrome-off"
                        id={this.props.id}
                        disabled={this.props.disabled}
                        type={this.props.type}
                        name={this.props.name}
                        value={this.props.value}
                        className={this.props.disabled === true? "disable" : this.props.class}
                        tabIndex={this.props.tabIndex}
                        placeholder={this.props.placeholder ? this.props.placeholder : this.props.type }
                        required={this.props.required ? true : false}
                        pattern={this.props.pattern}
                        onBlur={this.props.onBlur}
                        error={this.props.error}
                        valid={this.props.valid}
                        onChange={this.props.onChange}
                        onFocus={this.onClickHandler}
                        autoFocus={this.props.autoFocus}
                    />
                    <span className="inputName">{this.props.label}</span>
                </label>
                {this.state.showInfo &&
                <>
                <div
                    className={this.props.valid === false ? "" : "hide"}
                    data-testid={`${this.props.name}-error-label`}
                >
                    <Icon name="error"></Icon>
                    {this.props.error}
                </div>
                <div
                    className={this.props.info === false ? "" : "hide"}
                    data-testid={`${this.props.name}-info-label`}
                >
                    <Icon name="info" />
                    {this.props.infoMsg}
                </div>
                </>}
                {!this.props.required &&
                <>
                    <div className="optional">Optional</div>
                    <div className="clear"/>
                    </>
                }
                <div className="clear"/>

            </div>
        );
    }
}

export default RedwoodInputText;
